import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { FreeSpinReelControllerEvent as FreeSpinReelControllerEvent } from "./event/GameEvent";
import gsap from "gsap";
import { FreeSpinReelState } from "../model/GameModel";
import { FreeSpinOverlayEvent, SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
export class FreeSpinReelTransitionController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_START, this.transitionInStart);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_START, this.retriggerStart);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_START, this.transitionOutStart);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_START, this.gameOverStart);
    }
    async transitionInStart() {
        this.model.setFreeSpinReelState(FreeSpinReelState.TRANSITION_IN);
        const freeSpinsWon = this.model.getSpinResult().getReelSequence().getFreeSpinIndexes().length;
        this.startFreeSpinsSymbolCollection();
        for (let i = 0; i < freeSpinsWon; i++) {
            await this.blockUntil(FreeSpinOverlayEvent.FREE_SPIN_END);
        }
        await this.delayFor(1.5);
        this.model.setFreeSpinReelState(FreeSpinReelState.FREE_SPIN_REEL);
        this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_COMPLETE);
    }
    async retriggerStart() {
        const freeSpinsWon = this.model.getSpinResult().getReelSequence().getFreeSpinIndexes().length;
        this.startFreeSpinsSymbolCollection();
        for (let i = 0; i < freeSpinsWon; i++) {
            await this.blockUntil(FreeSpinOverlayEvent.FREE_SPIN_END);
        }
        await this.delayFor(1.5);
        this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_COMPLETE);
    }
    async startFreeSpinsSymbolCollection() {
        await this.delayFor(0.1);
        const spin = this.model.getSpinResult();
        const freeSpinIndexes = spin.getReelSequence().getFreeSpinIndexes();
        for (let i = 0; i < freeSpinIndexes.length; i++) {
            this.dispatchGame(SlingoEvent.FREE_SPIN_AWARD);
            await this.delayFor(1);
        }
    }
    async transitionOutStart() {
        this.model.setFreeSpinReelState(FreeSpinReelState.TRANSITION_OUT);
        await this.delayFor(0.5);
        this.model.setFreeSpinReelState(FreeSpinReelState.STANDARD_REEL);
        await this.delayFor(1);
        this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_COMPLETE);
    }
    async gameOverStart() {
        this.model.setFreeSpinReelState(FreeSpinReelState.TRANSITION_OUT);
        await this.delayFor(0.5);
        this.model.setFreeSpinReelState(FreeSpinReelState.STANDARD_REEL);
        await this.delayFor(1);
        this.dispatchGame(FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_COMPLETE);
    }
    ;
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, () => {
                this.unregisterGame(event);
                resolve();
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
}
//# sourceMappingURL=FreeSpinReelTransitionController.js.map